module.exports = __webpack_public_path__ + "img/slide3.196e1c85.jpg";